import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchCourse = () => api.get("/course").then((r) => r.data);
export const createUser = (name) => api.post("/users", { name }).then((r) => r.data);
export const getUser = (id) => api.get(`/users/${id}`).then((r) => r.data);
export const completeTopic = (userId, moduleId, topicId) =>
  api.post(`/users/${userId}/complete-topic`, { module_id: moduleId, topic_id: topicId }).then((r) => r.data);
export const toggleBookmark = (userId, topicId) =>
  api.post(`/users/${userId}/bookmark`, { topic_id: topicId }).then((r) => r.data);
export const submitQuiz = (userId, moduleId, topicId, answers) =>
  api
    .post(`/users/${userId}/quiz`, { module_id: moduleId, topic_id: topicId, answers })
    .then((r) => r.data);
export const markLinkedInShared = (userId) =>
  api.post(`/users/${userId}/linkedin-shared`).then((r) => r.data);
export const generateModuleImage = (moduleId) =>
  api.post(`/images/generate/${moduleId}`).then((r) => r.data);
export const getModuleImage = (moduleId) =>
  api.get(`/images/module/${moduleId}`).then((r) => r.data);

export const certificatePdfUrl = (userId) => `${API}/users/${userId}/certificate.pdf`;
export const certificateHtmlUrl = (userId) => `${API}/users/${userId}/certificate.html`;
export const emailCertificate = (userId, recipientEmail) =>
  api
    .post(`/users/${userId}/certificate/email`, { recipient_email: recipientEmail })
    .then((r) => r.data);
